import {
  getSenderAttachmentFileKind,
  isSenderAttachmentFileOversized,
  SENDER_MAX_IMAGE_SIZE_MB,
} from "@components/Sender/sender.fileAttachmentRules";
import {
  isPortfolioPdfFile,
  isPortfolioPdfOversized,
} from "../constants/uploadConstants";

/** Android / WebView picks may omit extension but provide image/* MIME. */
export function isPortfolioImageFile(file: File): boolean {
  if (getSenderAttachmentFileKind(file.name) === "image") {
    return true;
  }
  return (file.type || "").toLowerCase().startsWith("image/");
}

function isPortfolioImageFileOversized(file: File): boolean {
  if (!isPortfolioImageFile(file)) {
    return false;
  }
  if (getSenderAttachmentFileKind(file.name) === "image") {
    return isSenderAttachmentFileOversized(file);
  }
  return file.size > SENDER_MAX_IMAGE_SIZE_MB * 1024 * 1024;
}

export function isPortfolioUploadFileValid(
  file: File,
  uploadType: "image" | "pdf",
): boolean {
  return uploadType === "pdf"
    ? isPortfolioPdfFile(file)
    : isPortfolioImageFile(file);
}

export function isPortfolioUploadFileOversized(
  file: File,
  uploadType: "image" | "pdf",
): boolean {
  return uploadType === "pdf"
    ? isPortfolioPdfOversized(file)
    : isPortfolioImageFileOversized(file);
}
